module.exports = __webpack_public_path__ + "media/images/common/fb-f529a74c37f4fcc24a5c60e5b5534b03.svg";